import React from "react";
import  './login.css'
import image from '../../assets/img/login.png'; 
import InputGroup from '../../components/molecule/InputGroup/InputGroup'

const Login = () => {

    return(
        <section className="d-flex flex-column justify-content-center h-100 align-items-center">
            <div className="div-login">
                <img alt="Imagem Login" src={image} />
                <div className="div-container">
                    <div className="div-header">
                        <div className="div-tab">
                            <div className="active text-center tab">
                                <span className="cursor-pointer cl-green text-extra-bold">ENTRAR</span>
                            </div>
                            <div className="text-center bb-2-gray tab">
                                <span className="cursor-pointer cl-gray text-extra-bold">CADASTRAR</span>
                            </div>
                        </div>
                        <div className="div-sign-api">
                            <button className="btn btn-default">Google</button>
                            <button className="btn btn-default">Outlook</button>
                        </div>
                        <div className="div-continue">
                            <div></div>
                            <span>ou continuar com</span>
                            <div></div>
                        </div>
                        <div>
                            <div>
                                <InputGroup type="text" label="E-mail" name="email" id="email" placeholder="economiza@gmail.com" />
                            </div>
                            <div>
                                <InputGroup type="password" label="Senha" name="password" id="email" placeholder="..." />   
                            </div>
                            <div>
                                <div>
                                    <input />
                                    <span>Mantenha-me conectado</span>
                                </div>
                                <span>Esqueci minha senha</span>        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default Login;